import { CrudService } from '@/services/crud.service';
import { ValidatorResult } from '@onrunning/backstage-models';
import type { DocumentModel } from '../../../models/document.model';
import type { CatalogData } from '../types/catalog-pdf.types';
export class CatalogPdfService {
  private readonly crudService: CrudService<DocumentModel>;

  constructor() {
    this.crudService = new CrudService<DocumentModel>('api/catalog');
  }

  public async getSeasonCatalogData(accountId: string, seasonName: string): Promise<ValidatorResult<CatalogData>> {
    const queryParams = new URLSearchParams();
    queryParams.set('accountId', accountId);
    queryParams.set('seasonName', seasonName);

    return this.crudService.do('GET', `account?${queryParams}`);
  }
}
